import React, { useEffect, useContext, useCallback } from "react";
import useMap from "../../useMap";
import ContextMenuInteractionReadOnly, { extractMapEventFeature } from "./ContextMenu/MapContextMenuReadOnly";
import { getUtil } from "../../../../utils/positionable";
import { Context as InteractionContext } from "../InteractionContext";
import { Context as SelectionContext } from "../Select/SelectFeature";
import DataSourceContext from "../../DataSourceContext";
import { MapEditorRouteContext } from "../../../CustomRoutes/MapEditor";


function FeatureDetails({ readOnly = false }) {
  const map = useMap();
  const interactionContext = useContext(InteractionContext);

  const selectionContext = useContext(SelectionContext);
  const dataSourceContext = useContext(DataSourceContext);
  const {
    setMode,
    setPositionableSourceModel,
    positionableSourceModel
  } = useContext(InteractionContext);
  const mapEditorRouteContext = useContext(MapEditorRouteContext);

  const getProjectUploadOptions = useCallback(
    (event, contextmenuFeature) => {
      const geometryType = contextmenuFeature && contextmenuFeature.get("geometry").getType();
      const selectedFeature = selectionContext.getSelectedFeature();
      const isRecentInsp = 
        mapEditorRouteContext.inspections?.length > 0 && 
        mapEditorRouteContext.inspections[0].id === mapEditorRouteContext.selectedInspection?.id;
      const selectedInspectionId = mapEditorRouteContext.selectedInspection?.id;
      const isInitialInspection = mapEditorRouteContext.inspections?.length === 1;
      const allowEditDueToSpecialInspection = !(selectedInspectionId) || isInitialInspection;
      
      // Check if feature is newly added (unsaved) - these don't have positionables_id yet
      const isNewFeature = selectedFeature && !selectedFeature.get('positionables_id');

      return (contextmenuFeature && contextmenuFeature.values_ && (contextmenuFeature.values_.positionable_type === "control_measure" || contextmenuFeature.values_.positionable_type === "pollutant"))
        ? (selectedFeature && selectedFeature.values_.is_deleted !== undefined && selectedFeature.values_.is_deleted === true)? [] : [
            {
              action: "modify",
              label: geometryType === "Point" ? "Move" : "Edit",
              onClick: () => {
                const feature = selectionContext.getSelectedFeature();

                if (feature) {
                  setPositionableSourceModel(null);
                  setMode("modify", { feature });
                }
              },
              isDisabled: (selectedFeature?.values_?.disable_options || (!isRecentInsp && !isNewFeature && !allowEditDueToSpecialInspection))? true : false,
              disabledMessage: (selectedFeature?.values_?.disable_options)? `${geometryType === "Point" ? "Move" : "Edit"} option is disabled because this legend item is deleted in future inspections !` : (!isRecentInsp && !isNewFeature && !allowEditDueToSpecialInspection) ? `Legend item cannot be ${geometryType === "Point" ? "moved" : "edited"} in previous versions of map!` : null
            },
            {
              action: "delete",
              label: "Remove From Map",
              onClick: event => {
                let feature = selectionContext.getSelectedFeature();

                if (!feature && event.feature) {
                  feature = event.feature;
                }

                if (feature) {
                  setMode("delete", {
                    feature,
                  });
                }
              },
              isDisabled: selectedFeature?.values_?.disable_options ?? false,
              disabledMessage: (selectedFeature?.values_?.disable_options)? `Remove From Map option is disabled because this legend item is deleted in future inspections !` : null
            },
          ] : []
    },
    [dataSourceContext, selectionContext],
  );

  const handleClick = useCallback(
    event => {
      const feature = extractMapEventFeature(event, map);

      let util;

      if (feature) {
        util = getUtil(feature.get("positionable_type"));
      }

      /**
       * Show overlay only if clicked on a feature
       * and overlay is supported by feature.
       *
       * If no feature clicked, close overlay, if active
       */
      if (feature && util && util.hasOverlay()) {
        interactionContext.setMode("detail", {
          feature,
          readOnly,
        });
      } else {
        interactionContext.setDefaultMode();
      }
    },
    [interactionContext],
  );

  useEffect(() => {
    map.on("singleclick", handleClick);

    return () => {
      map.un("singleclick", handleClick);
    };
  }, []);

  if(readOnly){
    return <ContextMenuInteractionReadOnly getProjectUploadOptions={getProjectUploadOptions} readOnly={readOnly} positionableSourceModel = {positionableSourceModel} />;
  }

  return <div />;
}

export default FeatureDetails;
